module.exports = "/fonts/ARIALI.woff?3a1b5242ba16566eea1a84b95dadf683";